import React, { useState, useEffect } from 'react';
import Classes from '../MainLayout.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Notifications from '../../../GlobalComponents/Notification/Notifcation';
import { useSelector } from 'react-redux';
import AdminNotify from '../../AdminNotify/NotiPopup';

const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 448 512">
    <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
  </svg>
);

export default function Header({ setopenMobileSidebar, isMobile }) {
  const location = useLocation();
  const navigateTo = useNavigate();
  const { user } = useSelector((s) => s.auth || {});

  const [activePage, setActivePage] = useState(location.pathname);
  const [openNotify, setOpenNotify] = useState(false);

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location.pathname]);

  const isAdminLike =
    user?.role === "admin" ||
    user?.role === "company";

  function formatPageTitle(pathname) {
    if (pathname === '/' || pathname === '/dashboard') return "Dashboard";
    if (pathname === '/messages') return "Messages";
    if (pathname === '/services') return "Services";
    if (pathname === '/appointments') return "Appointments";
    if (pathname === '/add-appointment') return "Add appointment";
    if (pathname === '/clients') return "Clients";
    if (pathname === '/add-client') return "Add client";
    if (pathname === '/invoices') return "Invoices";
    if (pathname === '/add-invoice') return "Add invoice";
    if (pathname === '/settings') return "Settings";
    if (pathname === '/routes') return "Routes";
    if (pathname === '/information') return "Information";
    if (pathname === '/team') return "Team";
    if (pathname === '/contact-us') return "Contact us";
    if (pathname === '/availability') return "Availability";
    return "";
  }

  return (
    <>
      <header className={Classes.navbar}>

        {/* Mobile Title */}
        {isMobile ? (
          <div onClick={() => setopenMobileSidebar(true)} className="flexAlign10">
            <MenuIcon />
            <h4 className={Classes.headTitle}>
              {formatPageTitle(activePage)}
            </h4>
          </div>
        ) : (
          <>
            {activePage === "/" ? (
              <div>
                <h5>Hello, {user?.name || user?.firstName || user?.email}!</h5>
              </div>
            ) : (
              <div></div>
            )}
          </>
        )}

        {/* RIGHT SIDE ICONS + NOTIFY BUTTON */}
        <div className={Classes.headerRight}>

          {/* 📣 Notify Button — only admin/company */}
          {isAdminLike && (
            <button
              className={Classes.notifyBtnHeader}
              onClick={() => setOpenNotify(true)}
            >
              Notify
            </button>
          )}

          <div
            className={Classes.tooltipCon}
            onClick={() => navigateTo('/contact-us')}
          >
            <div className={Classes.tooltipHead}><h5>?</h5></div>
          </div>

          <Notifications />
        </div>
      </header>

      {/* 📣 Popup */}
      <AdminNotify
        open={openNotify}
        onClose={() => setOpenNotify(false)}
      />
    </>
  );
}
